import angular from 'angular';
import moment from 'moment';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import DocumentService from '@/shared/services/DocumentService';

angular
  .module('cloudX')
  .controller('FiscalCostDialog', [
    '$http',
    'appUrls',
    'flySvc',
    'checkSecurity',
    '$element',
    'close',
    'relationId',
    'data',
    'documents',
    fiscalCostDialog,
  ]);

function fiscalCostDialog(
  $http,
  appUrls,
  flySvc,
  checkSecurity,
  $element,
  close,
  relationId,
  data,
  documents,
) {
  var vm = this;
  vm.saving = false;
  vm.loading = false;
  vm.readOnly = !checkSecurity('Relation:u');
  vm.showValidation = false;
  vm.datepickerOptions = {
    startingDay: 1,
    initDate: moment
      .utc()
      .startOf('day')
      .toDate(),
  };
  vm.relationId = relationId;
  vm.documentsAccessor = {};
  vm.documentLinkType = 7;
  vm.documents = [...(documents || [])];
  vm.documentsChanged = false;
  vm.onDocumentsChanged = function() {
    vm.documentsChanged = true;
  };
  vm.realEstates = [];
  vm.selectedRealEstate = {};

  var getRealEstates = () => {
    vm.loading = true;
    $http.get(`${appUrls.api}/api/Fiscal/realEstates/${relationId}`).then(
      function(result) {
        vm.realEstates = result.data;
        setupViewModels();
      },
      function(error) {
        flySvc.error(error);
        setupViewModels();
      },
    );
  };
  getRealEstates();

  var setupViewModels = () => {
    vm.cost = angular.extend(
      {
        relationId: relationId,
        type: null,
        reference: null,
        professionalUsePercentage: null,
        remark: null,
        endUser: null,
        vatDeductionPercentage: null,
      },
      data,
    );

    vm.endUser = {
      relation: vm.cost.endUser,
      text: vm.cost.endUserName,
    };
    vm.selectedRealEstate = vm.cost.realEstateId
      ? vm.realEstates.find(x => x.id === vm.cost.realEstateId)
      : null;
    vm.loading = false;
  };

  vm.endUserChanged = function() {
    const { relation = null, text = null } = vm.endUser || {};

    vm.cost.endUser = relation;
    vm.cost.endUserName = text;
  };
  vm.isValid = function() {
    if (!vm.form) return false;
    if (vm.form.$invalid) return false;
    if (vm.cost.endUser && !vm.cost.endUser.id) return false;

    return true;
  };

  vm.save = function() {
    if (!vm.isValid()) return '';
    if (vm.saving) return '';

    var model = {
      ...vm.cost,
      realEstateId: vm.selectedRealEstate?.id,
    };

    vm.saving = true;
    $http.post(`${appUrls.api}/api/Fiscal/Cost`, model).then(
      function({ data }) {
        if (data.id) {
          vm.cost.id = data.id;
          if (vm.documentsAccessor && vm.documentsAccessor.uploadNewDocuments) {
            return vm.documentsAccessor.uploadNewDocuments(data.id).then(changed => {
              vm.saving = false;
              flySvc.success();

              close([data, changed || vm.documentsChanged ? vm.documents : null], 500);
              $element.modal('hide');
            });
          }
        }

        vm.saving = false;
        flySvc.success();

        close([data, vm.documentsChanged ? vm.documents : null], 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error);
        return '';
      },
    );
  };

  vm.cancel = function() {
    close([null, vm.documentsChanged ? vm.documents : null], 500);
  };
}
